/** Name parts sufficient for Ideon agent list/detail display. */
export interface IdeonAgentNameParts {
  firstName?: string
  middleName?: string
  lastName?: string
}

export function formatIdeonAgentName(a: IdeonAgentNameParts): string {
  return [a.firstName, a.middleName, a.lastName].filter(Boolean).join(' ')
}
